import { IComponentOptions, IController } from 'angular';
import './auth-activation-candidate-info.component.scss';

export class AuthActivationInfoController implements IController {
  email: string;
}

export const AuthActivationCandidateInfoComponent: IComponentOptions = {
  controller: AuthActivationInfoController,
  transclude: {
    header: '?authActivationInfoHeader',
    text: '?authActivationInfoText'
  },
  template: require('./auth-activation-candidate-info.component.html'),
  bindings: {
    email: '@'
  }
};



// WEBPACK FOOTER //
// ./app/states/auth/components/auth-activation-info/auth-activation-candidate-info.component.ts